import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function PrivateRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F1116]">
        <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">checking session…</div>
      </div>
    );
  }
  if (status !== "owner") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
